const config = {
  imageBase: "/imgs/",
};

export default config;
